import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AppSide, AppStatesGridHeaderNames, EnabledCustomerUsersGridHeaderNames, PopupHeaderTexts } from 'src/app/constants';

declare let bootstrap: any;

@Component({
  selector: 'app-check-revoke-state-om',
  templateUrl: './check-revoke-state-om.component.html',
  styleUrls: ['./check-revoke-state-om.component.scss']
})
export class CheckRevokeStateOmComponent implements OnInit, OnChanges, OnDestroy {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  popupHeaderTexts = PopupHeaderTexts;

  @Input() usersData: any;

  enabledCustUsersTableConfigOptions = {
    columns: [
      {
        headerName: EnabledCustomerUsersGridHeaderNames.user,
        hide: false
      },
      {
        headerName: EnabledCustomerUsersGridHeaderNames.domainName,
        hide: false
      }]
  }

  myModal: any;

  appSide = AppSide;

  destroySubscription = false;

  constructor() {

  }

  ngOnInit(): void {

  }

  openModal() {
    this.myModal = new bootstrap.Modal(document.getElementById('revokeStateDataPopupOm'), {
      backdrop: 'static', keyboard: false
    });

    this.myModal.show();
  }

  closeRevokeStateDataPopup() {
    this.usersData.splice(0, this.usersData.length);
    this.myModal.hide();
  }

  createIdString() {
     if (this.fromComponent && this.sectionName) {
      return this.fromComponent + '-' + this.sectionName + '-revokeStatePopup'
    } else {
      return 'revokeStatePopup';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.usersData) {
      this.openModal();
    }
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }

}
